import { useState, useEffect } from 'react';
import { api } from './lib/api.js';

// Lazy-load the monolith to keep the auth shell fast
import { lazy, Suspense } from 'react';
const Studio = lazy(() => import('./legacy-monolith.jsx'));

function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const res = await api.post('/api/auth/login', { email, password });
    if (res.error) {
      setError(res.error);
    } else {
      onLogin(res.user);
    }
    setLoading(false);
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0d0d0f' }}>
      <form onSubmit={handleSubmit} style={{ width: 320, display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <span style={{ fontFamily: '"JetBrains Mono", monospace', fontWeight: 500, color: '#fff', fontSize: 18 }}>3.2.1 </span>
          <span style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 200, color: '#fff', fontSize: 18 }}>studio</span>
        </div>
        {error && <p style={{ color: '#fe9d81', fontSize: 13, margin: 0 }}>{error}</p>}
        <input
          type="email" value={email} onChange={e => setEmail(e.target.value)}
          placeholder="email" required autoFocus
          style={{ background: '#1a1a1d', border: '1px solid #2a2a30', borderRadius: 8, padding: '10px 14px', color: '#fff', fontSize: 14, outline: 'none' }}
        />
        <input
          type="password" value={password} onChange={e => setPassword(e.target.value)}
          placeholder="password" required
          style={{ background: '#1a1a1d', border: '1px solid #2a2a30', borderRadius: 8, padding: '10px 14px', color: '#fff', fontSize: 14, outline: 'none' }}
        />
        <button type="submit" disabled={loading}
          style={{ background: 'linear-gradient(135deg, #aeb2e9, #fe9d81)', border: 'none', borderRadius: 8, padding: '11px 0', color: '#000', fontWeight: 600, fontSize: 14, cursor: loading ? 'wait' : 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'signing in…' : 'sign in'}
        </button>
      </form>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get('/api/auth/me').then(res => {
      if (res.user) setUser(res.user);
      setChecking(false);
    });
  }, []);

  if (checking) return null;
  if (!user) return <LoginScreen onLogin={setUser} />;

  return (
    <Suspense fallback={null}>
      <Studio currentUser={user} onLogout={() => {
        api.post('/api/auth/logout', {}).then(() => setUser(null));
      }} />
    </Suspense>
  );
}
